import { render, staticRenderFns } from "./wizard-information.vue?vue&type=template&id=65d3b669&scoped=true&lang=pug"
import script from "./wizard-information.vue?vue&type=script&lang=ts"
export * from "./wizard-information.vue?vue&type=script&lang=ts"
import style0 from "./wizard-information.vue?vue&type=style&index=0&id=65d3b669&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d3b669",
  null
  
)

export default component.exports